$('body').delegate('.custom_option_collection','change',function(){
  var custom_option = $(this).data('swatchcustom');
  $(this).parent().parent().find('.custom_option_collection').each(function(){
    
    if($(this).data('swatchcustom') == custom_option){
      $(this).prop('checked',true)
      $(this).addClass('swatch_active')
    }else{
      $(this).prop('checked',false)
      $(this).removeClass('swatch_active')
    
    }
  })
  var selected_options = ''
    $(this).closest('.custom_options').find('.custom_option_collection').each(function(){
      if($(this).is(":checked")){
        new_symbol ='';
           if(selected_options != ''){
             new_symbol =' / ';
           }
          selected_options = selected_options + new_symbol+ $(this).val()
      }
      
    })
  
  $(this).closest('.custom_options').next().find('.grid_variant_ced').each(function(){
    if($(this).text() == selected_options){
      if($(this).data('grid-variant-available') == true){
        var err_elem = $(this).parent().next();
        err_elem.text('')
      var grid_variant = $(this).data('grid-variant-id');
      
      let Data = {
      'items': [{
       id: grid_variant,
       quantity: 1
      }]
      };
      $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              dataType: 'json',
            data:  Data,
            success: function(json){
             var cart = new theme.CartDrawer
              cart.init()
              cart.open();
              
              // $.getJSON("/cart.js", function(cart){ 
              //       $('.cart-link__bubble').addClass('cart-link__bubble--visible')
              //     $('.cart-link__bubble').text('('+cart.item_count+')')
              //     })
                $('.custom_option_collection').each(function(){
                  if($(this).data('option-name-catriona') == 'size' && !$(this).attr('disabled')){
                     $(this).prop('checked',false)
                  $(this).prop('disabled',false)
                $(this).removeClass('swatch_active')
                  $('.swatch_opt_color_name').text('')
                  }
                 
                })
                },
              error:  function(xhr, status, error){console.log(xhr.responseText);}
           })
      }else{
       err_elem.text('Variant Not Available')
      }
    }
  })
})

// $('body').delegate('.custom_option_collection','change',function(){
//   var optionvaluecompare = $(this).val();
//   var optionnamecomapre = $(this).parent().parent().data('optionnameforvalue')
//   var comparr = [];
//   $(this).closest('.custom_options').next().find('.grid_variant_ced').each(function(){
//     var alloptioncompare = $(this).text().split('/').map(function (value) {
//    return value.trim();
//   });
//     if(alloptioncompare.includes(optionvaluecompare) && $(this).data('grid-variant-available')){
//       var optioncompareindex = alloptioncompare.indexOf(optionvaluecompare)
//       alloptioncompare.splice(optioncompareindex,1)
//       comparr.push(...alloptioncompare)
//     }
//   })
//   // console.log(comparr)
//   var newcomparr = [...new Set(comparr)]
//   $(this).closest('.custom_options').find('.custom_options_value').each(function(){
//     if($(this).data('optionnameforvalue') != optionnamecomapre){
//       $(this).find('.custom_option_collection').each(function(){
//         if(newcomparr.includes($(this).val())){
//           $(this).prop('disabled',false)
//         }else{
//           $(this).prop('disabled',true)
//         }
//       })
//     }
//   })
// })

$('.custom_options').each(function(){
  var option =''
  var arr = [];
  $(this).find('.custom_options_value').each(function(){
  
  if($(this).attr('data-optionnameforvalue') != 'size'){
    
    $(this).find('.custom_option_collection').each(function(){
      if($(this).is(':checked')){
        var symbol = ''
        if(option != ''){
          symbol =' / '
        }
        option = option + symbol + $(this).val()
      }
    })  
  }
  if($(this).attr('data-optionnameforvalue') == 'size'){
    $(this).find('.custom_option_collection').each(function(){
      var newopt = ''
      var symbol = ''
        if(option != ''){
          symbol =' / '
        }
        newopt = option + symbol + $(this).val()
         arr.push(newopt)
    })
   
  }
})
  
 $(this).next().find('.grid_variant_ced').each(function(){
   if(arr.includes($(this).text())){
     var variant = $(this).text().split(' / ');
     var variant_available = $(this).attr('data-grid-variant-available')
     $(this).closest('.grid-product__content').find('.custom_options_value').each(function(){
      if($(this).attr('data-optionnameforvalue') == 'size'){
    
      $(this).find('.custom_option_collection').each(function(){
        if(variant.includes($(this).val()) && variant_available == 'false' ){
          $(this).prop('disabled',true)
          console.log($(this).val())
        }
      })
      }
     })
   }
 })
})
  

// login form

var emailErr = '',
pswErr = '';
$(".customer_email").keyup(function () {
$("#customer_login").attr("onsubmit", '');
let email = $(this).val();
emailErr = checkEmailLogin(email);
});
$(".customer_password").keyup(function () {
$("#customer_login").attr("onsubmit", '');
let psw = $(this).val();
pswErr = checkPswLogin(psw);
});
$(".form-login").click(function (e) {
 e.preventDefault();
var email = $(".customer_email").val();
var psw = $(".customer_password").val();
emailErr = checkEmailLogin(email);
pswErr = checkPswLogin(psw);
if (emailErr === true && pswErr === true) {
  $("#customer_login").submit();
}
});
/*
* recovery form validate
*/
var emailRevErr='';
function checkRecoveryEmail(email) {
if (email === "") {
  $(".recovery_email_error").removeClass("custom-hide").addClass("custom-show");
  $(".recovery_email_error").html("This field is required.");
  return false;
} else if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) || email.match(/^[0-9]/)) {
  $(".recovery_email_error").removeClass("custom-hide").addClass("custom-show");
  $(".recovery_email_error").html("Invalid email.");
  return false;
 // $error1 = false;
} else {
  $(".recovery_email_error").removeClass("custom-hide").addClass("custom-show");
  $(".recovery_email_error").html("");
  return true;
}
}
$(".customer_recovery_email").keyup(function () {

let email = $(this).val();
emailRevErr = checkRecoveryEmail(email);
});
$(".submit-recovery").click(function (e) {
 e.preventDefault();
var email = $(".customer_recovery_email").val();
emailRevErr = checkRecoveryEmail(email);
  
if (emailRevErr === true) {
  $(".recover_password_ced").submit();
}
});
/*
* recovery form validate end
*/


function checkEmailLogin(email) {
if (email === "" || email.charAt(0) === " ") {
  $("#LoginForm-email-error").html("This field is required.");
  return false;
} else if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) || email.match(/^[0-9]/)) {
  $("#LoginForm-email-error").html("Invalid email.");
  return false;
 // $error = false;
} else {
  $("#LoginForm-email-error").html("");
  return true;
}
}
function checkPswLogin(psw) {
if (psw === "") {
  $("#LoginForm-password-error").html("This field is required.");
  return false;
} else {
  $("#LoginForm-password-error").html("");
  return true;
}
}

// login end

//register form

$(document).ready(function () {
  var fnameErr = '',
    lnameErr = '',
    emailErr = '',
    pswErr = '';
  $("#FirstName").keyup(function () {
    $("#create_customer").attr("onsubmit", '');
    let fname = $(this).val();
    fnameErr = checkFname(fname);
  });
  $("#LastName").keyup(function () {
    $("#create_customer").attr("onsubmit", '');
    let lname = $(this).val();
    lnameErr = checkLname(lname);
  });
  $("#Email").keyup(function () {
    $("#create_customer").attr("onsubmit", '');
    let email = $(this).val();
    emailErr = checkEmail(email);
  });
  $("#CreatePassword").keyup(function () {
    $("#create_customer").attr("onsubmit", '');
    let psw = $(this).val();
    pswErr = checkPsw(psw);
  });
  $(".create_form-submit").click(function (e) {
    $("#create_customer").attr("onsubmit", '');
    e.preventDefault();
    let error = false;

    var fname = $("#FirstName").val(),
      lname = $("#LastName").val(),
    email = $("#Email").val(),
    psw = $("#CreatePassword").val(),
    fnameErr = checkFname(fname),
    lnameErr = checkLname(lname),
    emailErr = checkEmail(email),
    pswErr = checkPsw(psw);
    if (fnameErr === true && lnameErr === true && emailErr === true && pswErr === true) {
      $("#create_customer").submit();
    }
  });


  function checkFname(fname) {
    if (fname === "") {
      $("#RegisterForm-fname-error").html("This field is required.");
      return false;
    }else if (fname.charAt(0) === " ") {
      $("#RegisterForm-fname-error").html("* Name should not start with Blank Spaces.");
      return false;
    }else if (!fname.match(/^[A-Za-z\s\-]+$/)) {
      $("#RegisterForm-fname-error").html("Only letters and white space allowed.");
      return false;
    } else if (fname.length < 3) {
      $("#RegisterForm-fname-error").html("Length should be greater than 2.");
      return false;
    } else {
      $("#RegisterForm-fname-error").html("");
      return true;
    }
  }
  function checkLname(lname) {
    if (lname != '' && !lname.match(/^[A-Za-z\s\-]+$/)) {
      $("#RegisterForm-lname-error").html("Only letters and white space allowed.");
      return false;
    } else if (lname != '' && lname.length < 3) {
      $("#RegisterForm-lname-error").html("Length should be greater than 2.");
      return false;
    } else {
      $("#RegisterForm-lname-error").html("");
      return true;
    }
  }
  function checkEmail(email) {
    if (email === "" || email === " ") {
      $("#RegisterForm-email-error").html("This field is required.");
      return false;
    } else if (!email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) || email.match(/^[0-9]/)) {
      $("#RegisterForm-email-error").html("Invalid email.");
      $error = false;
    } else {
      $("#RegisterForm-email-error").html("");
      return true;
    }
  }
  function checkPsw(psw) {
    if (psw === "") {
      $("#RegisterForm-password-error").html("This field is required.");
      return false;
    }
    else if (psw.length < 5) {
      $("#RegisterForm-password-error").html("Password is too short (minimum is 5 characters).");
      return false;
    } else {
      $("#RegisterForm-password-error").html("");
      return true;
    }
  }


});

// contact form

$(".contact_name").keyup(function () {
  $(".contact-form").attr("onsubmit", '');
  let fname = $(this).val();
  fnameErr = checkContactname(fname);
});
$(".contact_message").keyup(function () {
  $(".contact-form").attr("onsubmit", '');
  let lname = $(this).val();
  lnameErr = checkContactMes(lname);
});
$(".contact_email").keyup(function () {
  $(".contact-form").attr("onsubmit", '');
  let email = $(this).val();
  emailErr = checkContactEmail(email);
});
$(".contact_phone").keyup(function () {
  $(".contact-form").attr("onsubmit", '');
  let psw = $(this).val();
  pswErr = checkContactPhn(psw);
});

$(".contact-submit").click(function (e) {
  $(".contact-form").attr("onsubmit", '');
  e.preventDefault();
  let error = false;

  var cname = $(".contact_name").val(),
    cmes = $(".contact_message").val(),
  cemail = $(".contact_email").val(),
  cphn = $(".contact_phone").val(),
  cnameErr = checkContactname(cname),
  mesErr = checkContactMes(cmes),
  cemailErr = checkContactEmail(cemail),
  phnErr = checkContactPhn(cphn);
  if (cnameErr === true && mesErr === true && cemailErr === true && phnErr === true) {
    console.log('dsa')
    $(".contact-form").submit();
  }
});
function checkContactname(cname) {
  if (cname === "") {
    $(".nameerror").html("This field is required.");
    return false;
  }else if (cname.charAt(0) === " ") {
    $(".nameerror").html("* Name should not start with Blank Spaces.");
    return false;
  }
  else if (!cname.match(/^[A-Za-z\s\-]+$/)) {
    $(".nameerror").html("Only letters, white space and dash allowed.");
    return false;
  } else if (cname.length < 3) {
    $(".nameerror").html("Length should be greater than 2.");
    return false;
  } else {
    $(".nameerror").html("");
    return true;
  }
}
function checkContactEmail(cemail) {
  if (cemail === "" || cemail.charAt(0) === " ") {
    $(".cnemailerror").html("This field is required.");
    return false;
  } else if (!cemail.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/) || cemail.match(/^[0-9]/)) {
    $(".cnemailerror").html("Invalid email.");
    $error = false;
  } else {
    $(".cnemailerror").html("");
    return true;
  }
}
function checkContactMes(cmes) {
  if (cmes === "") {
    $(".messerror").html("This field is required.");
    return false;
  }else{
    $(".messerror").html("");
    return true;
  }
}

function checkContactPhn(cphn) {
  if (cphn === "") {
    $(".phnerror").html("This field is required.");
    return false;
  }else if (cphn.charAt(0) === " ") {
    $(".phnerror").html("* Phone should not start with Blank Spaces.");
    return false;
  }
  else if (!cphn.match(/^[0-9]+[0-9]*$/)){
     $(".phnerror").html("Invalid Number.");
      return false;
  }else{
     $(".phnerror").html("");
    return true;
  }
}

//tab collections

$('body').delegate('.tab_button','click',function(){
  var tab_button_data = $(this).data('buttoncollection');
  $(this).closest('.tab-collection-section').find('.tab_button').each(function(){
    if($(this).data('buttoncollection') == tab_button_data){
      if(!$(this).hasClass('active_tab_button')){
        $(this).addClass('active_tab_button');
      }
    }else{
      $(this).removeClass('active_tab_button')
    }
  })

  $(this).closest('.tab-collection-section').find('.tab_collection_products').each(function(){
    if($(this).data('blockcollection') == tab_button_data){
      if(!$(this).hasClass('active_tab')){
        $(this).addClass('active_tab');
      }
    }else{
      $(this).removeClass('active_tab')
    }
  })
})


$('body').delegate('.product_link_btn','click',function(){
  location.href = $(this).data('href')
})

$('body').delegate('.additional_checkout_btn','click',function(){
  var productid = $(this).closest('.product-single__meta').find($('.product-single__variants')).val()
  location.href= $(this).data('shopurl')+'/cart/'+productid+':'+$(this).closest('.product-single__meta').find('.product_quantity_ced').val()
})

// $('body').on('click', '.additional_checkout_btn', function() {

//   var productid = $(this)
//       .closest('.product-single__meta')
//       .find('.product-single__variants')
//       .val();

//   var quantity = $(this)
//       .closest('.product-single__meta')
//       .find('.product_quantity_ced')
//       .val();

//   var shopUrl = $(this).data('shopurl');

//   if(productid && quantity){
//       window.location.href = shopUrl + '/cart/' + productid + ':' + quantity;
//   } else {
//       console.log('Variant ya quantity select karein');
//   }

// });

document.addEventListener("click", function(event) {
  if (event.target.classList.contains("accorion_filter_btn")) {
    event.target.classList.toggle("accordion_active");
    var panel = event.target.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  }
});
